@if (iconDefinition()) {
  <span uiicon [class]="iconClass()">{{
    iconDefinition()?.startsWith('@custom-icon-')
      ? ''
      : iconDefinition()?.toLowerCase()
  }}</span>
}
